import { render, staticRenderFns } from "./aboutour.vue?vue&type=template&id=2aca6cd9&scoped=true&"
import script from "./aboutour.vue?vue&type=script&lang=js&"
export * from "./aboutour.vue?vue&type=script&lang=js&"
import style0 from "./aboutour.vue?vue&type=style&index=0&id=2aca6cd9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca6cd9",
  null
  
)

export default component.exports